var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFIlterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14H15.75M2.25 14H3.75M3.75 14C3.75 15.0355 4.58947 15.875 5.625 15.875C6.66053 15.875 7.5 15.0355 7.5 14C7.5 12.9645 6.66053 12.125 5.625 12.125C4.58947 12.125 3.75 12.9645 3.75 14ZM15 9.5H15.75M2.25 9.5H7.5M9.75 5H15.75M9.75 5C9.75 3.96447 8.91053 3.125 7.875 3.125C6.83947 3.125 6 3.96447 6 5C6 6.03553 6.83947 6.875 7.875 6.875C8.91053 6.875 9.75 6.03553 9.75 5ZM2.25 5H3M12.375 11.375C11.3395 11.375 10.5 10.5355 10.5 9.5C10.5 8.46447 11.3395 7.625 12.375 7.625C13.4105 7.625 14.25 8.46447 14.25 9.5C14.25 10.5355 13.4105 11.375 12.375 11.375Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFIlterBlack);
export default __webpack_public_path__ + "static/media/FIlterBlack.3154afbfa5f866bebba44e63f401b523.svg";
export { ForwardRef as ReactComponent };